import { Outlet, Link } from 'react-router-dom'
import { TrendingUp } from 'lucide-react'

/**
 * Minimal layout for authentication pages (login, register).
 * No sidebar. Centered form with brand logo.
 */
export function AuthLayout() {
  return (
    <div className="min-h-screen bg-slate-950 flex flex-col">
      {/* Background gradient */}
      <div className="fixed inset-0 bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 -z-10" />
      <div className="fixed top-0 left-1/4 w-96 h-96 bg-brand-500/5 rounded-full blur-3xl -z-10" />
      <div className="fixed bottom-0 right-1/4 w-96 h-96 bg-brand-600/5 rounded-full blur-3xl -z-10" />

      {/* Top bar with logo */}
      <div className="flex items-center justify-between px-6 py-4 border-b border-slate-800/50">
        <Link to="/" className="flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-brand-600 to-brand-500 flex items-center justify-center shadow-lg shadow-brand-900/50">
            <TrendingUp size={16} className="text-white" />
          </div>
          <div>
            <p className="text-xs font-bold text-slate-100 leading-none">UMKM Cockpit</p>
            <p className="text-[10px] text-slate-500 leading-none mt-0.5">Business Intelligence</p>
          </div>
        </Link>

        <span className="text-[10px] text-slate-600">MVP v0.1</span>
      </div>

      {/* Centered content */}
      <div className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="w-full max-w-sm">
          <Outlet />
        </div>
      </div>

      {/* Footer */}
      <div className="py-4 text-center">
        <p className="text-[10px] text-slate-700">
          © 2026 UMKM Business Cockpit. Built for Indonesian founders.
        </p>
      </div>
    </div>
  )
}
